import {
  AccountsApiFactory,
  AddressesApiFactory,
  AuthApiFactory,
  ChannelpartnersApiFactory,
  Configuration,
  CountriesApiFactory,
  CustomizationsApiFactory,
  Fido2PreRegisteredShipmentsApiFactory,
  InventoryAllocationsApiFactory,
  InventoryApiFactory,
  OrganizationsApiFactory,
  ProductsApiFactory,
  PurchaseOrdersApiFactory,
  RefundsApiFactory,
  ShipmentsApiAxiosParamCreator,
  ShipmentsApiFactory,
  UsersApiFactory,
} from '@libraries/api/gen-api';
import {
  BannerApiFactory as AdminBannersApiFactory,
  ChannelpartnersApiFactory as ChannelpartnersAdminApiFactory,
  Configuration as ConfigurationAdmin,
  CountriesApiFactory as CountriesAdminApiFactory,
  CustomizationsApiFactory as CustomizationAdminApiFactory,
  CustomizationsApiFactory as CustomizationsAdminApiFactory,
  CustomproductredeemApiFactory as CustomproductredeemAdminApiFactory,
  DashboardApiFactory as DashboardAdminApiFactory,
  DistributorsApiFactory as DistributorsAdminApiFactory,
  FeatureTogglesApiFactory as AdminFeatureTogglesApiFactory,
  FinancialReportApiFactory as FinancialReportAdminApiFactory,
  FprShipmentsApiFactory as FprShipmentsAdminApiFactory,
  GrantsApiFactory as GrantsApiFactoryAdmin,
  InventoryAllocationApiFactory as InventoryAllocationAdminApiFactory,
  InventoryApiFactory as InventoryAdminApiFactory,
  ItemsApiFactory,
  MachineTokenApiFactory,
  MachineTokensApiFactory,
  ManualShipmentsApiFactory as ManualShipmentsAdminApiFactory,
  NotificationsApiFactory as NotificationsAdminApiFactory,
  OrganizationsApiFactory as OrganizationsAdminApiFactory,
  ProductsApiFactory as ProductsAdminApiFactory,
  PurchaseOrdersApiFactory as PurchaseOrdersAdminApiFactory,
  RefundsApiFactory as RefundsAdminApiFactory,
  ResellersApiFactory as ResellersAdminApiFactory,
  ShipmentsApiAxiosParamCreator as ShipmentsAdminUrlGen,
  ShipmentsApiFactory as ShipmentsAdminApiFactory,
  UsersApiFactory as UsersAdminApiFactory,
} from '@libraries/api/gen-api-admin';
import {
  PartnersApiFactory as PartnersAdminApiFactory,
  RulesApiFactory as RulesAdminApiFactory,
  TokensApiFactory as TokensAdminApiFactory,
} from '@libraries/api/gen-api-fulfillment';
import {
  BannersApiFactory as HiddenBannersApiFactory,
  CustomizationsApiFactory as HiddenCustomizationsApiFactory,
  DashboardApiFactory as HiddenDashboardApiFactory,
  DistributorApiFactory as HiddenDistributorApiFactory,
  EmailTemplatesApiFactory as HiddenEmailTemplatesApiFactory,
  FeatureTogglesApiFactory as HiddenFeatureTogglesApiFactory,
  GrantsApiFactory as HiddenGrantsApiFactory,
  InventoryAllocationApiFactory as HiddenInventoryAllocationApiFactory,
  InventoryApiFactory as HiddenInventoryApiFactory,
  NotificationsApiFactory as HiddenNotificationsApiFactory,
  OrganizationApiFactory,
  PermissionsApiFactory as HiddenPermissionsFactory,
  PurchaseordersApiFactory as HiddenPurchaseOrderApiFactory,
  ResellerApiFactory as HiddenResellerApiFactory,
  ShipmentsApiFactory as HiddenShipmentsApiFactory,
  UploadsApiFactory as HiddenUploadsApiFactory,
} from '@libraries/api/gen-api-hidden';
import { SamlConfigurationApiFactory } from '@libraries/api/gen-api-hidden-sso';

import axiosClient from '../axios';

const configuration: Configuration = undefined;

export const basePath: string = window.fromServer.env.API_URL;

export const api = {
  AuthApi: AuthApiFactory(configuration, basePath, axiosClient),
  PermissionsApi: HiddenPermissionsFactory(configuration, basePath, axiosClient),
  BannersApi: HiddenBannersApiFactory(configuration, basePath, axiosClient),
  PurchaseOrdersApi: PurchaseOrdersApiFactory(configuration, basePath, axiosClient),
  UsersApi: UsersApiFactory(configuration, basePath, axiosClient),
  AddressesApi: AddressesApiFactory(configuration, basePath, axiosClient),
  ShipmentsApi: ShipmentsApiFactory(configuration, basePath, axiosClient),
  InventoryApi: InventoryApiFactory(configuration, basePath, axiosClient),
  InventoryHiddenApi: HiddenInventoryApiFactory(configuration, basePath, axiosClient),
  ProductsApi: ProductsApiFactory(configuration, basePath, axiosClient),
  CountriesApi: CountriesApiFactory(configuration, basePath, axiosClient),
  AccountsApi: AccountsApiFactory(configuration, basePath, axiosClient),
  OrganizationsApi: OrganizationsApiFactory(configuration, basePath, axiosClient),
  OrganizationApi: OrganizationApiFactory(configuration, basePath, axiosClient),
  EmailTemplatesApi: HiddenEmailTemplatesApiFactory(configuration, basePath, axiosClient),
  ChannelpartnersApi: ChannelpartnersApiFactory(configuration, basePath, axiosClient),
  ShipmentsHiddenApi: HiddenShipmentsApiFactory(configuration, basePath, axiosClient),
  RefundsApi: RefundsApiFactory(configuration, basePath, axiosClient),
  SamlConfigurationApi: SamlConfigurationApiFactory(configuration, basePath, axiosClient),
  DashboardHiddenApi: HiddenDashboardApiFactory(configuration, basePath, axiosClient),
  ResellerHiddenApi: HiddenResellerApiFactory(configuration, basePath, axiosClient),
  DistributorHiddenApi: HiddenDistributorApiFactory(configuration, basePath, axiosClient),
  PurchaseordersHiddenApi: HiddenPurchaseOrderApiFactory(configuration, basePath, axiosClient),
  InventoryAllocationApi: InventoryAllocationsApiFactory(configuration, basePath, axiosClient),
  InventoryAllocationHiddenApi: HiddenInventoryAllocationApiFactory(configuration, basePath, axiosClient),
  Fido2PreRegisteredShipmentsApi: Fido2PreRegisteredShipmentsApiFactory(configuration, basePath, axiosClient),
  CustomizationApi: CustomizationsApiFactory(configuration, basePath, axiosClient),
  CustomizationsApiHidden: HiddenCustomizationsApiFactory(configuration, basePath, axiosClient),
  UploadsHiddenApi: HiddenUploadsApiFactory(configuration, basePath, axiosClient),
  NotificationsHiddenApi: HiddenNotificationsApiFactory(configuration, basePath, axiosClient),
  FeatureTogglesHiddenApi: HiddenFeatureTogglesApiFactory(configuration, basePath, axiosClient),
  GrantsHiddenApi: HiddenGrantsApiFactory(configuration, basePath, axiosClient),
};

const configurationAdmin: ConfigurationAdmin = undefined;
export const apiAdmin = {
  PurchaseOrdersApi: PurchaseOrdersAdminApiFactory(configurationAdmin, basePath, axiosClient),
  InventoryAllocationApi: InventoryAllocationAdminApiFactory(configurationAdmin, basePath, axiosClient),
  UsersApi: UsersAdminApiFactory(configurationAdmin, basePath, axiosClient),
  OrganizationsApi: OrganizationsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  ProductsApiAdmin: ProductsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  ShipmentsApiAdmin: ShipmentsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  InventoryApiAdmin: InventoryAdminApiFactory(configurationAdmin, basePath, axiosClient),
  CustomProductRedeemsApiAdmin: CustomproductredeemAdminApiFactory(configurationAdmin, basePath, axiosClient),
  CountriesApiAdmin: CountriesAdminApiFactory(configurationAdmin, basePath, axiosClient),
  ChannelpartnersApiAdmin: ChannelpartnersAdminApiFactory(configurationAdmin, basePath, axiosClient),
  FinancialReportApiAdmin: FinancialReportAdminApiFactory(configurationAdmin, basePath, axiosClient),
  RulesApiAdmin: RulesAdminApiFactory(configurationAdmin, basePath, axiosClient),
  PartnersApiAdmin: PartnersAdminApiFactory(configurationAdmin, basePath, axiosClient),
  RefundsApiAdmin: RefundsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  TokensApiAdmin: TokensAdminApiFactory(configurationAdmin, basePath, axiosClient),
  ManualShipmentsApiAdmin: ManualShipmentsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  DashboardApiAdmin: DashboardAdminApiFactory(configurationAdmin, basePath, axiosClient),
  MachineTokenApi: MachineTokenApiFactory(configurationAdmin, basePath, axiosClient),
  MachineTokensApi: MachineTokensApiFactory(configurationAdmin, basePath, axiosClient),
  FprShipmentsApiAdmin: FprShipmentsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  DistributorsApiAdmin: DistributorsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  ResellersApiAdmin: ResellersAdminApiFactory(configurationAdmin, basePath, axiosClient),
  CustomizationsApiAdmin: CustomizationsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  CustomizationApiAdmin: CustomizationAdminApiFactory(configurationAdmin, basePath, axiosClient),
  BannersApi: AdminBannersApiFactory(configurationAdmin, basePath, axiosClient),
  NotificationsApi: NotificationsAdminApiFactory(configurationAdmin, basePath, axiosClient),
  FeatureTogglesApi: AdminFeatureTogglesApiFactory(configurationAdmin, basePath, axiosClient),
  GrantsApi: GrantsApiFactoryAdmin(configurationAdmin, basePath, axiosClient),
  ItemsApi: ItemsApiFactory(configurationAdmin, basePath, axiosClient),
};

export const apiFulfillmentAdmin = {
  RulesApi: RulesAdminApiFactory(configurationAdmin, basePath, axiosClient),
  PartnersApi: PartnersAdminApiFactory(configurationAdmin, basePath, axiosClient),
  TokensApi: TokensAdminApiFactory(configurationAdmin, basePath, axiosClient),
};

export const apiUrlGen = {
  base: basePath,
  ShipmentUrlGen: ShipmentsApiAxiosParamCreator(configuration),
};

export const adminApiUrlGen = {
  base: basePath,
  AdminShipmentUrlGen: ShipmentsAdminUrlGen(configuration),
};

export const apiEnum = {};
